function initializePopup() {
  let popUp = document.getElementById("ask-for-a-price-pop-up");
  let overlay = document.getElementById("ask-for-a-price-overlay");
  let body = document.body;

  const getScrollbarWidth = () => {
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll';
    document.body.appendChild(outer);

    const inner = document.createElement('div');
    outer.appendChild(inner);

    const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

    outer.parentNode.removeChild(outer);

    return scrollbarWidth;
  };

  const openPopUp = () => {
    const scrollbarWidth = getScrollbarWidth();
    popUp.classList.add("opened");
    overlay.classList.add("opened");
    body.style.overflow = "hidden"; // Disable scrolling
    body.style.paddingRight = `${scrollbarWidth}px`; // Add padding to compensate for scrollbar
  };

  const closePopUp = () => {
    popUp.classList.remove("opened");
    overlay.classList.remove("opened");
    body.style.overflow = ""; // Enable scrolling
    body.style.paddingRight = ""; // Remove added padding
  };

  document.querySelectorAll("button.ask-for-a-price").forEach((button) => {
    button.addEventListener("click", (e) => {
      e.preventDefault();
      openPopUp();
    });
  });

  const contactForm = document.getElementById('ContactForm');
  if (contactForm) {
    contactForm.addEventListener("submit", (e) => {
      e.preventDefault();
    });
  }

  overlay.addEventListener("click", closePopUp);
  document
    .getElementById("ask-for-a-price-pop-up-close-button")
    .addEventListener("click", closePopUp);

  // Close the popup when the Escape key is pressed
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && popUp.classList.contains("opened")) {
      closePopUp();
    }
  });

  if (window.location.href.includes("?contact_posted=true")) {
    openPopUp();
  }
}

document.addEventListener("DOMContentLoaded", () => {
  initializePopup();
});
